import React from 'react';

const Technology = () => {
  return (
    <div className="page-content">
      {/* OPTION 9: Image Grid Collage Header */}
      <section className="page-hero service-hero-grid" style={{
        position: 'relative',
        minHeight: '500px',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        marginTop: '120px',
        paddingTop: '3rem',
        paddingBottom: '3rem'
      }}>
        {/* Image Grid Background */}
        <div className="service-hero-grid-bg" style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '1rem',
          padding: '1rem',
          zIndex: 1
        }}>
          {[...Array(8)].map((_, i) => (
            <div key={i} style={{
              background: `linear-gradient(${135 + i * 20}deg, rgba(0, 104, 166, 0.6) 0%, rgba(171, 22, 54, 0.6) 100%)`,
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <span className="material-icons" style={{fontSize: '3rem', color: 'rgba(255, 255, 255, 0.3)'}}>
                {['computer', 'settings', 'lightbulb', 'cloud', 'tablet_mac', 'view_in_ar', 'science', 'engineering'][i]}
              </span>
            </div>
          ))}
        </div>
        
        {/* Dark Overlay */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.7)',
          zIndex: 2
        }}></div>
        
        <div className="container" style={{position: 'relative', zIndex: 3, textAlign: 'center', padding: '4rem 20px'}}>
          <div style={{maxWidth: '800px', margin: '0 auto'}}>
            <div className="service-badge" style={{
              display: 'inline-block',
              fontSize: '0.9rem',
              fontWeight: '600',
              color: 'var(--white)',
              letterSpacing: '2px',
              textTransform: 'uppercase',
              paddingBottom: '0.5rem',
              borderBottom: '3px solid var(--accent-blue)',
              marginBottom: '2rem'
            }}>
              Professional Services
            </div>
            
            <h1 className="service-title" style={{
              color: 'var(--white)',
              fontSize: '4.5rem',
              fontWeight: '700',
              marginBottom: '1.5rem',
              lineHeight: '1.1'
            }}>
              Technology and Innovation
            </h1>
            
            <p className="service-subtitle" style={{
              color: 'rgba(255, 255, 255, 0.95)',
              fontSize: '1.5rem',
              lineHeight: '1.6',
              marginBottom: '0'
            }}>
              Cutting-edge technology solutions for modern mechanical systems and project delivery
            </p>
          </div>
        </div>
      </section>

      {/* Section 1: Technology in the Office */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Technology in the Office</h2>
            <p>State-of-the-art facilities for seamless digital communication and collaboration</p>
          </div>
          
          <div className="precon-grid-2col" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center', marginBottom: '3rem'}}>
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '1.5rem'}}>
                Bel-Aire Mechanical is continually updating our technology to keep at the forefront of what is available to <strong style={{color: 'var(--accent-blue)'}}>increase productivity and reduce overall cost</strong>. We work with the newest and industry standard software to ensure digital communication is as smooth as possible.
              </p>
              
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)'}}>
                Bel-Aire can host a varying range of meetings including advanced conference facilities and comprehensive IT support to ensure optimal collaboration and project coordination.
              </p>
            </div>
            
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [High Tech Conference Room Image]
            </div>
          </div>
          
          <div style={{maxWidth: '1000px', margin: '0 auto'}}>
            <div className="tech-office-grid" style={{
              display: 'grid', 
              gridTemplateColumns: 'repeat(3, 1fr)', 
              gap: '1rem'
            }}>
              <div className="tech-office-card" style={{
                background: 'var(--white)', 
                padding: '1.5rem', 
                borderRadius: '8px', 
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', 
                textAlign: 'center',
                border: '2px solid var(--accent-blue)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent-blue)', marginBottom: '0.5rem'}}>Large High Tech Conference Room</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Advanced meeting facilities with cutting-edge technology</p>
              </div>
              <div className="tech-office-card" style={{
                background: 'var(--white)', 
                padding: '1.5rem', 
                borderRadius: '8px', 
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', 
                textAlign: 'center',
                border: '2px solid var(--accent2-red)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent2-red)', marginBottom: '0.5rem'}}>Private Huddle Room</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Top-management collaboration space</p>
              </div>
              <div className="tech-office-card" style={{
                background: 'var(--white)', 
                padding: '1.5rem', 
                borderRadius: '8px', 
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', 
                textAlign: 'center',
                border: '2px solid var(--accent-blue)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent-blue)', marginBottom: '0.5rem'}}>Multi-Row Training Room</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Large capacity training and presentation facility</p>
              </div>
              <div className="tech-office-card" style={{
                background: 'var(--white)', 
                padding: '1.5rem', 
                borderRadius: '8px', 
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', 
                textAlign: 'center',
                border: '2px solid var(--accent2-red)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent2-red)', marginBottom: '0.5rem'}}>Multiple Huddle Rooms</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Wired and wireless display capabilities</p>
              </div>
              <div className="tech-office-card" style={{
                background: 'var(--white)', 
                padding: '1.5rem', 
                borderRadius: '8px', 
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', 
                textAlign: 'center',
                border: '2px solid var(--accent-blue)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent-blue)', marginBottom: '0.5rem'}}>Microosft Teams</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Professional meeting hosting capabilities</p>
              </div>
              <div className="tech-office-card" style={{
                background: 'var(--white)', 
                padding: '1.5rem', 
                borderRadius: '8px', 
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', 
                textAlign: 'center',
                border: '2px solid var(--accent2-red)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent2-red)', marginBottom: '0.5rem'}}>IT Support</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>On-site and remote technical support</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: Technology in the Field */}
      <section className="section" style={{background: 'linear-gradient(180deg, var(--white) 0%, var(--secondary-light) 100%)'}}>
        <div className="container">
          <div className="section-header">
            <h2>Technology in the Field</h2>
            <p>Advanced field technology for enhanced collaboration and communication</p>
          </div>
          
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center'}} className="precon-grid-2col">
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [Field Technology Centers Image]
            </div>
            
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '2rem'}}>
                Bel-Aire Mechanical takes advantage of both hardware and software current technologies to <strong style={{color: 'var(--accent-blue)'}}>increase collaboration and communication between our project personnel</strong> including comprehensive field technology solutions.
              </p>
              
              <div style={{background: 'var(--accent-blue)', color: 'var(--white)', padding: '2rem', borderRadius: '10px'}}>
                <h3 style={{color: 'var(--white)', fontSize: '1.3rem', marginBottom: '1rem'}}>Field Technology Solutions</h3>
                <p style={{fontSize: '1.05rem', lineHeight: '1.7', color: 'rgba(255, 255, 255, 0.95)', margin: 0}}>
                  Our field technology infrastructure ensures seamless connectivity between project sites and our home office, enabling real-time collaboration, data sharing, and enhanced safety management for all commercial projects.
                </p>
              </div>
            </div>
          </div>
          
          <div style={{maxWidth: '1000px', margin: '3rem auto 0'}}>
            <div className="tech-field-grid" style={{
              display: 'grid', 
              gridTemplateColumns: 'repeat(3, 1fr)', 
              gap: '1rem'
            }}>
              <div className="tech-field-card" style={{
                background: 'var(--white)', 
                padding: '1.5rem', 
                borderRadius: '8px', 
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', 
                textAlign: 'center',
                border: '2px solid var(--accent-blue)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent-blue)', marginBottom: '0.5rem'}}>Cloud Data Sharing</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Seamless cloud-based communication systems</p>
              </div>
              <div className="tech-field-card" style={{
                background: 'var(--white)', 
                padding: '1.5rem', 
                borderRadius: '8px', 
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', 
                textAlign: 'center',
                border: '2px solid var(--accent2-red)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent2-red)', marginBottom: '0.5rem'}}>Field Trailer Huddle</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Advanced workstations in field trailers</p>
              </div>
              <div className="tech-field-card" style={{
                background: 'var(--white)', 
                padding: '1.5rem', 
                borderRadius: '8px', 
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', 
                textAlign: 'center',
                border: '2px solid var(--accent-blue)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent-blue)', marginBottom: '0.5rem'}}>Field Technology Centers</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Dedicated FTC worksite facilities</p>
              </div>
              <div className="tech-field-card" style={{
                background: 'var(--white)', 
                padding: '1.5rem', 
                borderRadius: '8px', 
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', 
                textAlign: 'center',
                border: '2px solid var(--accent2-red)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent2-red)', marginBottom: '0.5rem'}}>Home Office Connectivity</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Direct connectivity to main office systems</p>
              </div>
              <div className="tech-field-card" style={{
                background: 'var(--white)', 
                padding: '1.5rem', 
                borderRadius: '8px', 
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', 
                textAlign: 'center',
                border: '2px solid var(--accent-blue)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent-blue)', marginBottom: '0.5rem'}}>BIM 360 Field</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Advanced field management platform</p>
              </div>
              <div className="tech-field-card" style={{
                background: 'var(--white)', 
                padding: '1.5rem', 
                borderRadius: '8px', 
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', 
                textAlign: 'center',
                border: '2px solid var(--accent2-red)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent2-red)', marginBottom: '0.5rem'}}>Safety Management</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Technology-enhanced safety protocols</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 3: Technology in Preconstruction */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Technology in Preconstruction</h2>
            <p>Advanced tools and software for precise project planning and execution</p>
          </div>
          
          <div className="precon-grid-2col" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center', marginBottom: '3rem'}}>
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '2rem'}}>
                Bel-Aire Mechanical leverages cutting-edge preconstruction technology to ensure accurate project planning and seamless execution. Our technology stack includes <strong style={{color: 'var(--accent-blue)'}}>mobile devices for project requirements capture</strong>, advanced estimating software, and experienced estimators to ensure no surprises arise during construction.
              </p>
              
              <div style={{background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', color: 'var(--white)', padding: '2.5rem', borderRadius: '10px', boxShadow: '0 6px 25px rgba(171, 22, 54, 0.3)'}}>
                <h3 style={{color: 'var(--white)', fontSize: '1.3rem', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.75rem'}}>
                  <span className="material-icons" style={{fontSize: '1.5rem'}}>precision_manufacturing</span>
                  BIM Technology Integration
                </h3>
                <p style={{fontSize: '1.05rem', lineHeight: '1.8', color: 'rgba(255, 255, 255, 0.95)', margin: 0}}>
                  Our field experienced BIM modelers utilize the current version of Autodesk Building Design Suite Ultimate on high-powered workstations, combined with cloud data-sharing capabilities to deliver precise preconstruction planning and coordination.
                </p>
              </div>
            </div>
            
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [BIM Workstation and Mobile Devices Image]
            </div>
          </div>
          
          <div style={{maxWidth: '1000px', margin: '0 auto'}}>
            <div className="tech-precon-grid" style={{
              display: 'grid', 
              gridTemplateColumns: 'repeat(4, 1fr)', 
              gap: '1rem'
            }}>
              <div className="tech-precon-card" style={{
                background: 'var(--white)', 
                padding: '1.5rem', 
                borderRadius: '8px', 
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', 
                textAlign: 'center',
                border: '2px solid var(--accent-blue)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent-blue)', marginBottom: '0.5rem'}}>Mobile Devices</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Capture project requirements on-site</p>
              </div>
              <div className="tech-precon-card" style={{
                background: 'var(--white)', 
                padding: '1.5rem', 
                borderRadius: '8px', 
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', 
                textAlign: 'center',
                border: '2px solid var(--accent2-red)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent2-red)', marginBottom: '0.5rem'}}>Estimating Software</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Advanced estimation and planning tools</p>
              </div>
              <div className="tech-precon-card" style={{
                background: 'var(--white)', 
                padding: '1.5rem', 
                borderRadius: '8px', 
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', 
                textAlign: 'center',
                border: '2px solid var(--accent-blue)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent-blue)', marginBottom: '0.5rem'}}>Autodesk BIM Suite</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Building Design Suite Ultimate</p>
              </div>
              <div className="tech-precon-card" style={{
                background: 'var(--white)', 
                padding: '1.5rem', 
                borderRadius: '8px', 
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', 
                textAlign: 'center',
                border: '2px solid var(--accent2-red)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent2-red)', marginBottom: '0.5rem'}}>Cloud Data Sharing</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Seamless collaboration capabilities</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 4: Technology in Manufacturing */}
      <section className="section" style={{background: 'linear-gradient(180deg, var(--white) 0%, var(--secondary-light) 50%, rgba(0, 104, 166, 0.1) 100%)'}}>
        <div className="container">
          <div className="section-header">
            <h2>Technology in Manufacturing</h2>
            <p>Advanced manufacturing technology for precision fabrication and production</p>
          </div>
          
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center'}} className="precon-grid-2col">
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [Manufacturing Technology Equipment Image]
            </div>
            
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '2rem'}}>
                Along with our highly-skilled labor force, Bel-Aire has the <strong style={{color: 'var(--accent-blue)'}}>manufacturing technology to accomplish any task from the simple to the most complicated spools of pipe, runs of HVAC duct, or any custom sheet metal work</strong> that you may need.
              </p>
              
              <div style={{background: 'var(--accent-blue)', color: 'var(--white)', padding: '2rem', borderRadius: '10px'}}>
                <h3 style={{color: 'var(--white)', fontSize: '1.3rem', marginBottom: '1rem'}}>Advanced Manufacturing Capabilities</h3>
                <p style={{fontSize: '1.05rem', lineHeight: '1.7', color: 'rgba(255, 255, 255, 0.95)', margin: 0}}>
                  Our state-of-the-art manufacturing technology includes robotic systems, advanced cutting equipment, and precision welding technology, all integrated with our BIM and CAD systems for maximum efficiency and quality.
                </p>
              </div>
            </div>
          </div>
          
          <div style={{maxWidth: '1200px', margin: '3rem auto 0'}}>
            <div className="tech-manufacturing-grid" style={{
              display: 'grid', 
              gridTemplateColumns: 'repeat(3, 1fr)', 
              gap: '1.5rem'
            }}>
              <div className="tech-manufacturing-card tech-card-blue" style={{
                background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(0, 104, 166, 0.2)',
                textAlign: 'center'
              }}>
                <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>precision_manufacturing</span></div>
                <h3 style={{fontSize: '1.3rem', marginBottom: '1rem', color: 'var(--white)'}}>Robotic Cutting Systems</h3>
                <ul style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem', lineHeight: '1.6', textAlign: 'left', margin: 0}}>
                  <li>Robotic 2-axis plasma/oxy pipe cutting machine</li>
                  <li>Miller Jimmy Jammer manipulator oscillator pipe welder</li>
                  <li>Multiple 3000+ pound pipe positioners</li>
                  <li>Decreased labor costs and increased precision</li>
                </ul>
              </div>
              
              <div className="tech-manufacturing-card tech-card-red" style={{
                background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(171, 22, 54, 0.2)',
                textAlign: 'center'
              }}>
                <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>build</span></div>
                <h3 style={{fontSize: '1.3rem', marginBottom: '1rem', color: 'var(--white)'}}>Material Handling Systems</h3>
                <ul style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem', lineHeight: '1.6', textAlign: 'left', margin: 0}}>
                  <li>Multiple indoor cranes (215' travel)</li>
                  <li>Outdoor crane (125' travel)</li>
                  <li>Advanced material positioning systems</li>
                  <li>Efficient material handling operations</li>
                </ul>
              </div>
              
              <div className="tech-manufacturing-card tech-card-blue" style={{
                background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(0, 104, 166, 0.2)',
                textAlign: 'center'
              }}>
                <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>settings</span></div>
                <h3 style={{fontSize: '1.3rem', marginBottom: '1rem', color: 'var(--white)'}}>Advanced Fabrication Equipment</h3>
                <ul style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem', lineHeight: '1.6', textAlign: 'left', margin: 0}}>
                  <li>PPI Lockformer Vulcan Plasma table</li>
                  <li>PPI CAM software and Autodesk Fabrication CADduct</li>
                  <li>Multiple forming and breaking machines</li>
                  <li>Multiple roll coil line sheer</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Technology;
